SP.lang.Class.define("SP.sitekit.form.field.Field", {

	_control: null,
	_el: null,
	_options: null,
	_validators: null,

	init: function (el, options)  {

		var me = this;

		me._el = el;
		me._options = options;

		me.setValidators(this._options.validators);

		// SK: ".SP-Field__control" hinzugefügt, in "components" ist auch so gelöst
		me._control = el.querySelector(options.controlSelector || ".SP-Field__control");

		if (me._control === null) {
			return;
		}

		/* Validierung aktivieren */
		if (!me._control.hasAttribute("disabled")) {
			if (this.isCheckbox()) {
				// Sonderfall für Checkboxen: Validierung bei blur erzeugt ein verweirrendes Verhalten.
				me._control.addEventListener("change", function () {
					me.validate();
				});
			} else {
				me._control.addEventListener("blur", function () {
					me.validate();
				});
			}
		}

		// (jQuery UI) Datepicker: muss auf das Change-Event hören
		var type = options.type;
		type = type.substring(type.indexOf(".") + 1);
		if (type.toLowerCase() === "date" &&
				me._control.type.toLowerCase() === "text" &&
				$ &&
				$.fn.datepicker &&
				!me._control.hasAttribute("disabled")) {
			me._control.addEventListener("change", function () {
				me.validate();
			});
		}

		if (me._options.autosubmit && !me._control.hasAttribute("disabled")) {
			me._control.addEventListener(me._options.autosubmit, function (e) {
				SP.dom.Element.closest(me._el, "form").submit();
			});
		}
	},

	isCheckbox: function () {
		if (this._control.tagName.toLowerCase() !== "input") {
			return false;
		}

		if (!this._control.type) {
			return false;
		}

		return this._control.type.toLowerCase() === "checkbox";
	},

	/**
	 * Liefert das HTMLInputElement.
	 * Ist das Feld eine Feldgruppe, wird das erste Element zurück geliefert.
	 * @return HTMLInputElement
	 */
	getControl: function() {
		return this._control;
	},

	getValue: function () {
		if (this._control !== null) {
			return this._control.value;
		}
		return null;
	},

	isEmpty: function() {
		return SP.isEmpty(this.getValue());
	},

	setValidators: function(validators) {
		var me = this;

		if (validators) {
			if (!SP.isArray(validators)) {
				validators = [validators];
			}

			me._validators = [];
			validators.forEach(function(validator) {
				me.addValidator(validator);
			});
		}
	},

	addValidator: function(validator) {

		if (SP.isString(validator)){
			validator = {type:validator};
		}

		if (SP.isObject(validator)) {
			var type = validator.type;
			var clazz = type.charAt(0).toUpperCase() + type.slice(1);
			if (SP.sitekit.form.validator[clazz]) {
				this._validators.push(new SP.sitekit.form.validator[clazz](validator));
			}
		}
	},

	/**
	 * Validiert das Feld mit allen Validatoren. Liefert ein Validator false, wird die Prüfung abgebrochen und
	 * false zurück geliefert. Die Methode fn wird nach Abschluss der Validierung mit folgendem Objekt aufgerufen.
	 * {
	 * 	valid: true|false,
	 * 	message: "" // Fehlermeldung wenn valid=false
	 * }
	 *
	 * @param function fn Funktion, die nach Aufruf der Validierung aufgerufen wird.
	 * @return boolean Liefert true, wenn Validierung erfolgreich, sonst false.
	 */
	validate: function (fn) {
		var result = null;

		if (this._validators) {
			for (var i = 0; i < this._validators.length; i++) {
				if (!this._validators[i].isValid(this.getValue(), this._control, this)) {
					result = {
						field : this,
						valid : false,
						message: this._validators[i].getMessage()
					};
					break;
				}
			}
		}

		if (result === null) {
			result = {
				field : this,
				valid : true
			};
		}
		if (SP.isFunction(fn)) {
			fn(result);
		}

		if (result.valid) {
			this._setValid();
		} else {
			this._setInvalid(result.message);
		}

		return result.valid;
	},

	_setInvalid: function (message) {
		var me = this;

		me._el.classList.add("SP-isInvalid");

		var error = this._el.querySelector("[data-sp-form-field-error]");
		if (error) {
			error.innerHTML = message;
		} else {
			error = document.createElement("div");
			error.id = me._control.id + "-error";
			error.innerHTML = message;
			if (me._options.classes && me._options.classes.error) {
				var errorClasses = SP.isArray(me._options.classes.error) ? me._options.classes.error : [me._options.classes.error];
				SP.lang.Array.each(errorClasses, function(i, cls) {
					error.classList.add(cls);
				});
			}

			/* globals $ */
			if (window.$) {
				error.style.display = "none";
			} else {
				error.style.display = "block";
			}
			error.setAttribute("data-sp-form-field-error", "");
			error.setAttribute("role", "alert");
			error.setAttribute("aria-atomic", true);
			error.classList.add("SP-Field__error");

			me._appendErrorMessage(error);
			this.getControl().setAttribute("aria-describedby", error.id);

			/* globals $ */
			if (window.$) {
				error = this._el.querySelector("[data-sp-form-field-error]");
				$(error).slideDown(200);
			}
		}
	},

	_appendErrorMessage: function (error) {
		var annotation = this._el.querySelector("[data-sp-form-field-hint]");
		if (!annotation) {
			this._el.appendChild(error);
		} else {
			SP.dom.Element.insertBefore(annotation, error.outerHTML);
		}
	},

	_setValid: function () {
		var me = this;

		me._el.classList.remove("SP-isInvalid");
		me._el.classList.add("SP-isValid");
		setTimeout(function () {
			me._el.classList.remove("SP-isValid");
		}, 2000);

		this.getControl().removeAttribute("aria-describedby");
		var error = this._el.querySelector("[data-sp-form-field-error]");
		if (error) {
			/* globals $ */
			if (window.$) {
				$(error).slideUp(200, function () {
					try {
						error.parentNode.removeChild(error);
					} catch(e) {}
				});
			} else {
				try {
					error.parentNode.removeChild(error);
				} catch(e) {}
			}
		}
	}

});
